<template>
  <el-row
    justify="space-between"
    align="middle"
    style="height: 100%"
    class="header"
  >
    <div class="left">
      <!-- <div class="header-name" @click="switchOrgTreeRef.toggleShow()">
        {{ curOrgName }}
        <el-icon><CaretBottom /></el-icon>
      </div> -->
      <HBreadcrumb class="breadcrumb" style="margin-left: -1px" />
    </div>
    <Right />
  </el-row>
  <switch-org-tree ref="switchOrgTreeRef" @success="success"></switch-org-tree>
</template>

<script setup>
import Right from './right' 
import { HBreadcrumb } from '@/components'
import { setLsToken, setMctLevel } from '@/core/storage/ls'
import { ref } from 'vue'

import switchOrgTree from '@/business-components/switch-org-tree'
import { tabChangeOrganizationList } from '@/api/personnel-management'
import { orgListApi } from '@/api/marketing/activities-management'
import { CaretBottom } from '@element-plus/icons-vue'

const orgParams = ref({
  name: '',
  parent_id: undefined,
});

const curOrgName = ref(``);

const getCurOrg = async () => {
  const { error, result: { data } } = await orgListApi({
    ...orgParams.value
  });
  if (!error) {
    curOrgName.value = data[0].name;
  } 
};
getCurOrg();

const switchOrgTreeRef = ref(null);

const success = async (id) => {
  const { error, result: { data } } = await tabChangeOrganizationList(id);
  if (!error) {
    setLsToken(data.auth_token);
    setMctLevel(data.level);
    window.location.reload()
  }
}

</script>

<style lang="scss" scoped>
.header {
  /* background: var(--el-color-white); */
  /* border-radius: var(--el-border-radius-base); */
  /* padding: 4px 0; */
  /* box-shadow: 0px 4px 10px 0px rgba(78, 89, 105, 0.06); */
  padding-right: 10px;
  .left {
    display: flex;
    flex-direction: column;
    padding-left: 16px;
    .header-name {
      margin-top: 15px;
      cursor: pointer;
    }
    .breadcrumb {
      margin-top: 10px;
    }
  }
}
</style>
